"use client";
import { AboutPageQueryResult } from "@/sanity.types";
import { urlFor } from "@/sanity/lib/image";
import Image from "next/image";
import OurValuesDesktop from "./OurValuesDesktop";
import { useRef } from "react";

type OurValuesProps = {
	moduleData: NonNullable<AboutPageQueryResult>["companyValues"];
};

export default function OurValues({ moduleData }: OurValuesProps) {
	const { values } = moduleData;
	const sectionRef = useRef<HTMLElement>(null);

	return (
		<section id="targetScrollInAboutPage" ref={sectionRef} className="content-section relative lg:pb-16">
			<div className="grid grid-cols-2 gap-x-5 gap-y-16 sm:hidden">
				{values.map((value) => (
					<div key={value._key} className="col-span-2 sm:hidden">
						<div className="relative mb-10 aspect-[362/452] overflow-hidden rounded-lg">
							<Image src={urlFor(value.image).url()} alt={value.headline} fill className="object-cover" />
							<div className="bg-graphite-black/20 absolute inset-0" />
						</div>
						<h5 className="text-h5 text-graphite-black mb-5">{value.headline}</h5>
						<p className="text-body-m text-graphite-black/70">{value.text}</p>
					</div>
				))}
			</div>
			<OurValuesDesktop values={values} />
		</section>
	);
}
